import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { storefrontEnsureLogin } from '../mutations/storefrontEnsureLogin';
import { isEmailOnly } from 'dibs-cookie-jar/exports/isEmailOnly';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import { localStorage as dibsLocalStorage } from 'dibs-browser-storage';

import get from 'lodash.get';

import { CallDealerModal } from 'dibs-buyer-initiate-call';

class CallButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpened: false,
        };

        this.onFollowDealer = this.onFollowDealer.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    onFollowDealer() {
        const isFollowing = !!get(this.props, 'seller.favoritesByUser[0]');

        if (isFollowing) {
            this.setState({ isOpened: false });
            return;
        }

        this.props.followDealer();
        this.setState({ isOpened: false });
    }

    onClick() {
        if (isEmailOnly(document.cookie)) {
            authModalLoader.show({
                action: authModalLoader.constants.REQUEST_PASSWORD_EMAIL,
                flow: authModalLoader.constants.CREATE_PASSWORD_CALL_SELLER_FLOW,
                email: dibsLocalStorage.getItem('userEmail'),
                relayEnvironment: this.props.relay.environment,
            });
        } else {
            this.setState({ isOpened: true });
        }
    }

    render() {
        const { isOpened } = this.state;
        const { userId, className } = this.props;

        return (
            <div className={className} onClick={this.onClick} data-tn="storefront-head-call-button">
                {/* Call */}
                <FormattedMessage id="StorefrontCallButton.cta" defaultMessage="Call" />

                {/* Modal */}
                <CallDealerModal
                    location="storefront"
                    isOpened={isOpened}
                    userId={userId}
                    hasUserId={!!userId}
                    item={null}
                    conversation={null}
                    viewer={this.props.viewer}
                    seller={this.props.seller}
                    onClose={() => this.setState({ isOpened: false })}
                    onFollowDealer={this.onFollowDealer}
                    onAuthRequired={(onAuthSuccess, onAuthFailure) => {
                        storefrontEnsureLogin({
                            relayEnvironemnt: this.props.relay.environment,
                        })
                            .then(({ userId: newUserId }) => onAuthSuccess(newUserId))
                            .catch(onAuthFailure);
                    }}
                />
            </div>
        );
    }
}

CallButton.propTypes = {
    className: PropTypes.string.isRequired,

    userId: PropTypes.string,
    viewer: PropTypes.object.isRequired,
    seller: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,

    followDealer: PropTypes.func.isRequired,
};

export default createFragmentContainer(CallButton, {
    seller: graphql`
        fragment StorefrontCallButton_seller on Seller {
            serviceId
            favoritesByUser(userIds: $userId) @include(if: $hasUserId) {
                serviceId
            }
            ...CallDealerModal_seller
        }
    `,
    viewer: graphql`
        fragment StorefrontCallButton_viewer on Viewer {
            ...CallDealerModal_viewer
        }
    `,
});
